/// <reference path="../../../WebUI/typings/tsd.d.ts" />
/// <reference path="ControllerBase.ts" />

import {ControllerBase} from "./ControllerBase";
import { DevPortalAppBase } from "../DevPortalAppBase";
import * as Dialogs from "../Dialogs/MessageBox";

/**
 * Turn flighted features on or off.
 */
export class FlightController extends ControllerBase {
    constructor(app: DevPortalAppBase) {
        super(app);
    }

    public render(params: SimpleMvc.QueryParams): void {
        super.render(params);
        this.processParams(params);
        this.app.navigate('/');
    }

    private processParams(params: SimpleMvc.QueryParams): void {
        for (let feature in params) {
            if (params.hasOwnProperty(feature)) {
                let turnOn = params[feature] === 'on';
                this.app.setFeatureFlighting(feature, turnOn);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./Client/Controllers/FlightController.ts